import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import styled from '@emotion/styled'

import CloseIcon from '@mui/icons-material/Close'

import { postCancelFOI } from '../../dataClient/apiCalls'
import { StyledDialog, FlexEndContainer, FlexDialogContent, FlexColumn } from '../styles/Containers'
import { ErrorMessage } from '../common/UserMessage'
import Button, { SecondaryButton } from '../common/Button'
import BodyText, { BoldSpan, BoldFormTitle } from '../styles/Text'

const LargeCloseIcon = styled(CloseIcon)`
  && {
    width: 18px;
    height: 18px;
  }
`

function CancelRequestButton({ foiId, secondaryId, onSuccess = () => {} }) {
  const [isVisible, setIsVisible] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(false)

  const handleOpen = () => setIsVisible(true)
  const handleClose = () => {
    setIsVisible(false)
    setError(false)
    setIsLoading(false)
  }

  async function handleConfirm() {
    setIsLoading(true)
    setError(false)

    postCancelFOI(foiId, { cancelType: 'WITHDRAWN' })
      .then(() => {
        handleClose()
        onSuccess()
      })
      .catch(e => {
        console.error('Failed canceling request', e)
        setError(true)
        setIsLoading(false)
      })
  }

  const isMounted = useRef(true)

  useEffect(() => {
    return () => {
      isMounted.current = false
    }
  }, [])

  return (
    <>
      <SecondaryButton aria-label="Cancel Request" onClick={handleOpen}>
        <LargeCloseIcon />
        Cancel Request
      </SecondaryButton>
      <StyledDialog fullWidth open={isVisible} onClose={handleClose} keepMounted={false}>
        <FlexDialogContent>
          <FlexColumn>
            <BoldFormTitle>Cancel Request</BoldFormTitle>
            <BodyText>
              Are you sure you want to cancel <BoldSpan>{secondaryId}</BoldSpan>?
            </BodyText>
            {error && <ErrorMessage>There was an error cancelling the request. Please try again.</ErrorMessage>}
            <FlexEndContainer>
              <SecondaryButton onClick={handleClose} disabled={isLoading}>
                Go back
              </SecondaryButton>
              <Button onClick={handleConfirm} loading={isLoading}>
                Confirm
              </Button>
            </FlexEndContainer>
          </FlexColumn>
        </FlexDialogContent>
      </StyledDialog>
    </>
  )
}

CancelRequestButton.propTypes = {
  foiId: PropTypes.string.isRequired,
  secondaryId: PropTypes.string.isRequired,
  onSuccess: PropTypes.func
}

export default CancelRequestButton
